module.exports = __webpack_public_path__ + "static/media/icon_autonomo.8b6c2905.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_autonomo.svg
// module id = 616
// module chunks = 0